const LLout = JSON.parse(localStorage.getItem('layoutStore'));
const initialState = LLout 
                    ? {layout:LLout} : {layout: 'simple-layout'}

export const layout = {
    state: initialState,
    mutations: {
        SET_LAYOUT (state, payload) {
          state.layout = payload
          if(payload){
            localStorage.setItem('layoutStore',JSON.stringify(payload));
          }  
        }
      },
      getters: {
        layout (state) {
          return state.layout
        }
      }
}